import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container ptb-100" }
const _hoisted_2 = { class: "row gx-xxl-5" }
const _hoisted_3 = { class: "col-xl-4 col-lg-5 order-xl-1 order-lg-1 order-2" }
const _hoisted_4 = { class: "col-xl-8 col-lg-7 order-xl-2 order-lg-2 order-1" }
const _hoisted_5 = { class: "blog-img round-10 overflow-hidden" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "blog-info" }
const _hoisted_8 = { class: "blog-metainfo list-style" }
const _hoisted_9 = { class: "position-relative d-inline-block" }
const _hoisted_10 = { class: "position-relative d-inline-block" }
const _hoisted_11 = { class: "fs-34" }
const _hoisted_12 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarWidget = _resolveComponent("SidebarWidget")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SidebarWidget)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogs, (blog) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "blog-card mb-50",
            key: blog.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: blog.image,
                alt: "Image",
                class: "round-10 transition"
              }, null, 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("ul", _hoisted_8, [
                _createElementVNode("li", _hoisted_9, [
                  _createVNode(_component_router_link, { to: "/posts-by-author" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(blog.author), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(blog.date), 1)
                ])
              ]),
              _createElementVNode("h3", _hoisted_11, [
                _createVNode(_component_router_link, { to: "/blog-details-left-sidebar" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(blog.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("p", _hoisted_12, _toDisplayString(blog.desc), 1)
            ])
          ]))
        }), 128)),
        _cache[0] || (_cache[0] = _createStaticVNode("<ul class=\"page-nav list-style\"><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"><i class=\"ri-arrow-left-s-line\"></i></a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle active\" href=\"#\"> 01 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"> 02 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"> 03 </a></li><li><a class=\"d-flex flex-column justify-content-center align-items-center rounded-circle\" href=\"#\"><i class=\"ri-arrow-right-s-line\"></i></a></li></ul>", 1))
      ])
    ])
  ]))
}